<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.group_practice_periods', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.create" element="inertia-link">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.group')" for="group_id" />
                        <FormSelect
                            id="group_id"
                            v-model="form.group_id"
                            :options="options.groups"
                            :null-option="true"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.all')"
                        />
                        <FormError :value="form.errors.group_id" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.subject')" for="subject_id" />
                        <FormSelectFiltered
                            id="subject_id"
                            v-model="form.subject_id"
                            :options="options.subjects"
                            :null-option="true"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.all')"
                            filter-property="stage_id"
                            :filter-value="stageId"
                        />
                        <FormError :value="form.errors.group_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <AppWell class="mt-5">
            <div class="p-1 flex flex-col gap-5">
                <AppCard>
                    <div class="p-2">
                        <div class="flex gap-2">
                            <div>
                                <IconActivity class="text-gray-400" />
                            </div>

                            <div>{{ $t('messages.active') }}</div>
                        </div>

                        <GroupPracticeList :group-practices="activeGroupPractices" />
                    </div>
                </AppCard>
                <AppCard>
                    <div class="p-2">
                        <div class="flex gap-2">
                            <div>
                                <IconArrowBadgeRightFilled class="text-gray-400" />
                            </div>

                            <div>{{ $t('messages.scheduled') }}</div>
                        </div>

                        <GroupPracticeList :group-practices="futureGroupPractices" />
                    </div>
                </AppCard>
                <AppCard>
                    <div class="p-2">
                        <div class="flex gap-2">
                            <div>
                                <IconArrowBadgeLeftFilled class="text-gray-400" />
                            </div>

                            <div>{{ $t('messages.group_practice_finished') }}</div>
                        </div>

                        <GroupPracticeList :group-practices="finishedGroupPractices" />
                    </div>
                </AppCard>
            </div>
        </AppWell>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import FormLabel from '../../../components/Forms/FormLabel.vue';
import FormSelect from '../../../components/Forms/FormSelect.vue';
import FormError from '../../../components/Forms/FormError.vue';
import SubmitFormButton from '../Activities/Subactivities/SubmitFormButton.vue';
import FormSelectFiltered from '../../../components/Forms/FormSelectFiltered.vue';
import AppWell from '../../../Shared/AppWell.vue';
import AppCard from '../../../Shared/AppCard.vue';
import { IconActivity, IconArrowBadgeLeftFilled, IconArrowBadgeRightFilled } from '@tabler/icons-vue';
import GroupPracticeList from './partials/GroupPracticeList.vue';

export default {
    components: {
        GroupPracticeList,
        AppCard,
        AppWell,
        FormSelectFiltered,
        SubmitFormButton,
        FormError,
        FormSelect,
        FormLabel,
        PanelPage,
        AppButton,
        IconActivity,
        IconArrowBadgeLeftFilled,
        IconArrowBadgeRightFilled,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'activeGroupPractices', 'futureGroupPractices', 'finishedGroupPractices', 'options', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
                subject_id: this.filters.subject_id,
            }),
        };
    },
    computed: {
        stageId: function () {
            if (this.form.group_id === null) {
                return null;
            }
            const group = this.options.groups.find((g) => g.value === +this.form.group_id);
            if (group === undefined) {
                return null;
            }
            return group.stage_id;
        },
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
